export function getSpritesData(texturesOrTexture, imageSrc) {
  const textures = Array.isArray(texturesOrTexture)
    ? texturesOrTexture
    : [texturesOrTexture];
  const spriteIds = getIds(
    textures.map((t) => t.name),
    '/'
  );
  const spritesData = spriteIds.reduce((sprites, spriteId) => {
    const spriteTextures = textures.filter(
      (texture) => texture.name.split('/')[0] == spriteId
    );
    if (
      spriteTextures.length === 1 ||
      !hasSpriteStates(getSpriteTextureNames(spriteTextures))
    ) {
      return {
        ...sprites,
        [spriteId]: {
          id: spriteId,
          default: {
            id: 'default',
            frames: spriteTextures.map((texture, idx) => {
              return { idx, ...texture };
            }),
          },
          image: imageSrc,
        },
      };
    } else {
      const spriteStateIds = getIds(getSpriteTextureNames(spriteTextures), '_');
      return {
        ...sprites,
        [spriteId]: spriteStateIds.reduce((states, stateId) => {
          const stateTextures = spriteTextures.filter((tex) =>
            tex.name.includes(stateId)
          );
          return {
            id: spriteId,
            ...states,
            [stateId]: {
              id: stateId,
              frames: stateTextures.map((texture, idx) => {
                return {
                  idx,
                  ...texture,
                };
              }),
            },
            image: imageSrc,
          };
        }, {}),
      };
    }
  }, {});

  return spritesData;
}

function getIds(textureNames, separator) {
  return [...textureNames.map((name) => name.split(separator)[0])];
}

function hasSpriteStates(spriteTextureNames) {
  return spriteTextureNames.length > 1 && spriteTextureNames[0].split('_')[1];
}

function getSpriteTextureNames(spriteTextures) {
  return spriteTextures.map((texture) => texture.name.split('/')[1]);
}
